import { CopyPasteContext, CopyPasteHelper } from '../../editor/components/types';
import { editorComponentsDefinitions } from '../../editor/components/components';

const helperByComponentId: Record<string, CopyPasteHelper> = {};
editorComponentsDefinitions.forEach(component => {
  if (component.copyPasteHelper) {
    helperByComponentId[component.id] = component.copyPasteHelper;
  }
});

export function processComponentForCopyPaste(element: any, context: CopyPasteContext): void {
  return helperByComponentId[element.type]?.(element, context);
}
